import { z } from 'zod'

export const GenericCompanySchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1).max(128),
  short_name: z.string().min(1).max(16),
  address_1: z.string().min(1).max(64),
  address_2: z.string().max(64).nullable().optional(),
  country: z.string().min(1).max(64),
  city: z.string().min(1).max(64),
  postal_code: z.string().min(1).max(16),
  longitude: z.number().nullable().optional(),
  latitude: z.number().nullable().optional(),
  phone: z.string().min(1).max(32).optional().nullable(),
  email: z.string().email().max(254).optional().nullable(),
  web: z.union([z.string().url().max(254), z.literal('')]).nullable().optional(),
  vat_number: z.string().min(1).max(16).nullable().optional(),
  registration_number: z.string().max(16).nullable().optional(),
  activity_code: z.string().max(16).nullable().optional(),
  bank_account_no: z.string().min(1).max(32).optional().nullable(),
  notes: z.string().nullable().optional(),
})
